export const USER_SIGN_IN_CHECK = 'USER_SIGN_IN_CHECK';
export const USER_SIGN_IN_CHECK_REQUEST = 'USER_SIGN_IN_CHECK_REQUEST';
export const USER_SIGN_IN_CHECK_RESULT = 'USER_SIGN_IN_CHECK_RESULT';

export const USER_APP_SIGN_OUT = 'USER_APP_SIGN_OUT';
export const USER_SIGN_OUT_RESET = 'USER_SIGN_OUT_RESET'

export const HEADER_JS_SETED = 'HEADER_JS_SETED';

export const NOTICE_ADD = 'NOTICE_ADD';
export const NOTICE_REMOVE = 'NOTICE_REMOVE';

export const NOTIFICATION_GET = 'NOTIFICATION_GET'
export const NOTIFICATION_GET_RESULT = 'NOTIFICATION_GET_RESULT'
export const NOTIFICATION_GET_RESET = 'NOTIFICATION_GET_RESET'

export const NOTIFICATION_READ = 'NOTIFICATION_READ'
export const NOTIFICATION_READ_RESULT = 'NOTIFICATION_READ_RESULT'

export const NOTIFICATION_UNREAD_GET = 'NOTIFICATION_UNREAD_GET'
export const NOTIFICATION_UNREAD_GET_RESULT = 'NOTIFICATION_UNREAD_GET_RESULT'

export const LOAD_START = 'LOAD_START';
export const LOAD_END = 'LOAD_END';
// export const USER_SIGN_OUT_RESET = 'USER_SIGN_OUT_RESET';


// WEBPACK FOOTER //
// ./src/constants/App.js